/**
 * feat-300 — the two date shapes the thread uses (design NOTES §3.3, §4).
 *
 * - Message meta: `2:14 pm` today, else `2 Oct, 2:14 pm`.
 * - History line: `2 Oct`, plus the year when it is not this year.
 */
const time = (d: Date): string =>
  d
    .toLocaleTimeString('en-US', { hour: 'numeric', minute: '2-digit' })
    .replace(/\s?([AP])M$/i, (_m, p: string) => ` ${p.toLowerCase()}m`);

const dayMonth = (d: Date): string => `${d.getDate()} ${d.toLocaleString('en-GB', { month: 'short' })}`;

export function metaWhen(iso: string, now: Date = new Date()): string {
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return '';
  const sameDay =
    d.getFullYear() === now.getFullYear() &&
    d.getMonth() === now.getMonth() &&
    d.getDate() === now.getDate();
  return sameDay ? time(d) : `${dayMonth(d)}, ${time(d)}`;
}

export function historyDate(iso: string | null, now: Date = new Date()): string {
  if (!iso) return '';
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return '';
  return d.getFullYear() === now.getFullYear() ? dayMonth(d) : `${dayMonth(d)} ${d.getFullYear()}`;
}
